import { ChipProps, Components, Theme } from '@mui/material'
import isNil from 'lodash/isNil'

export const getPaletteValue = (
  theme: Theme,
  color: ChipProps['color'],
  property: 'light' | 'main' | '100' | 'contrastText'
): string | undefined => {
  const colorKey = isNil(color) ? 'primary' : color === 'default' ? 'neutral' : color
  const paletteColor = theme.palette[colorKey]
  return paletteColor[property]
}

export const MuiChip: Components<Omit<Theme, 'components'>>['MuiChip'] = {
  defaultProps: {
    variant: 'outlined',
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const color = ownerState.color

      return {
        backgroundColor: getPaletteValue(theme, color, 'light'),
        color: getPaletteValue(theme, color, 'main'),
        borderColor: getPaletteValue(theme, color, '100'),
        borderRadius: 6,
        height: theme.spacing(6),
      }
    },
    avatar: ({ ownerState, theme }) => {
      const color = ownerState.color

      const backgroundColor = getPaletteValue(theme, color, 'main')
      const textColor = getPaletteValue(theme, color, 'contrastText')

      return {
        lineHeight: '18px',
        borderRadius: 4,
        fontSize: 8,
        textAlign: 'center',
        marginLeft: 3,
        color: textColor,
        backgroundColor,
        '& .MuiTypography-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }
    },
  },
}
